import React, { FC } from 'react';

import Source from './Source';

import { MusicExportSource } from 'types/enums';
import { ExportSourcesProps } from './interfaces';

import useStyles from './style';

const ExportSources: FC<ExportSourcesProps> = ({ spotify, appleMusic, beatsource, people }) => {
  const classes = useStyles();

  return (
    <div className={classes.exportSources}>
      {spotify ? <Source source={MusicExportSource.spotify} {...spotify} /> : null}
      {appleMusic ? <Source source={MusicExportSource.appleMusic} {...appleMusic} /> : null}
      {beatsource ? <Source source={MusicExportSource.beatsource} {...beatsource} /> : null}
      {people ? <Source source={MusicExportSource.people} {...people} /> : null}
    </div>
  );
};

export default ExportSources;
